import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { legacyOrdersRouter } from './routing/legacyOrdersRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import {
  legacyOrdersDeliveryAccessControl,
  legacyOrdersPickupAccessControl,
} from './access-control/legacyOrdersAccess.configuration'

/**
 * Legacy Orders Domain Definition
 *
 * This domain contains the legacy orders functionality migrated from
 * packages/dashboard/src/legacy/sections/orders/. It supports:
 * - Delivery orders
 * - Pickup orders
 * - Scan & Pay orders
 */
const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'legacy-orders',
  totem: {
    tool: 'legacy-orders-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  routers: {
    scoped: [legacyOrdersRouter],
  },
  navigationEntries: [
    {
      attachToV3: NavEntryPointV3.CustomersAndOrders,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'View and manage delivery orders',
          labelId: 'legacyOrdersDomain.nav.delivery.title',
          labelIdV3: 'legacyOrdersDomain.nav.delivery.title.v3',
          route: 'legacy-orders-delivery',
          accessControl: legacyOrdersDeliveryAccessControl,
          positionNavV3: 3,
        },
        {
          type: 'item',
          llmDescription: 'View and manage pickup orders',
          labelId: 'legacyOrdersDomain.nav.pickup.title',
          labelIdV3: 'legacyOrdersDomain.nav.pickup.title.v3',
          route: 'legacy-orders-pickup',
          accessControl: legacyOrdersPickupAccessControl,
          positionNavV3: 4,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
